import request from '@/utils/request'

// 列表合約基本檔
export function getContracts(query) {
  return request({
    url: '/contract/contracts',
    method: 'get',
    params: query,
  })
}

// 儲存合約基本檔
export function saveContract(data) {
  return request({
    url: '/file/fileUpload',
    method: 'post',
    data,
  })
}

// 刪除合約基本檔
export function deleteContract(data) {
  return request({
    url: '/contract/deleteContract',
    method: 'post',
    data,
  })
}

// 產生簽署合約
export function generateContract(data) {
  return request({
    url: '/contract/generateContract',
    method: 'post',
    data,
  })
}

// 刪除簽署合約
export function deleteSignContract(data) {
  return request({
    url: '/contract/deleteSignContract',
    method: 'post',
    data,
  })
}
